import { db, auth } from "../Config/firebase";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  serverTimestamp,
  doc,
  updateDoc,
} from "firebase/firestore";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";

/* =========================
   CATEGORIAS
========================= */
export async function getCategorias() {
  const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_categorias")));
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));
}

export async function createCategoria({ codigo, titulo }) {
  return addDoc(collection(db, "sgq_categorias"), aplicarTenantAtual({
    codigo,
    titulo,
    ordem: Number(codigo),
    ativa: true,
    createdAt: serverTimestamp(),
  }));
}

export async function atualizarStatusCategoria(categoriaId, ativa) {
  return updateDoc(doc(db, "sgq_categorias", categoriaId), {
    ativa,
    updatedAt: serverTimestamp(),
  });
}

/* =========================
   DOCUMENTOS (MESTRE)
========================= */
export async function getDocumentosByCategoria(categoriaCodigo, incluirDadosEnvio = false) {
  const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_documentos")));
  const documentos = snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(documento => documento.categoriaCodigo === categoriaCodigo)
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  if (!incluirDadosEnvio || !documentos.length) return documentos;

  const historicoSnap = await getDocs(consultaTenantAtual(collection(db, "sgq_historico")));
  const revisoes = historicoSnap.docs
    .map(d => d.data())
    .filter(item => item.acao !== "edicaoDados")
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

  return documentos.map(documento => {
    const envio = revisoes.find(item =>
      item.documentoId === documento.id &&
      String(item.revisao).padStart(2, "0") === String(documento.revisaoAtual).padStart(2, "0")
    );
    return { ...documento, envioRevisaoAtual: envio || null };
  });
}

export async function getDocumentos() {
  const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_documentos")));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

    export async function createDocumento(docData) {
      return addDoc(collection(db, "sgq_documentos"), aplicarTenantAtual({
        ...docData,                 // ← respeita o valor vindo do frontend
        ativo: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      }));
    }


export async function atualizarDocumento(documentoId, dados) {
  return updateDoc(doc(db, "sgq_documentos", documentoId), {
    ...dados,
    updatedAt: serverTimestamp(),
  });
}

/* =========================
   HISTÓRICO / VERSIONAMENTO
========================= */
export async function getUltimaRevisao(documentoId) {
  const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_historico")));
  const itens = snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(item => item.documentoId === documentoId && item.acao !== "edicaoDados")
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  if (!itens.length) return null;

  return itens[0];
}

export async function createHistorico({
  documentoId,
  codigoISO,
  titulo,
  storagePath,
  revisao,
  acao = "revisao",
}) {
  const user = auth.currentUser;

  return addDoc(collection(db, "sgq_historico"), aplicarTenantAtual({
    documentoId,
    codigoISO,
    titulo,
    storagePath,
    revisao,
    acao,
    userId: user?.uid || null,
    userName: user?.displayName || user?.email || "Sistema",
    userEmail: user?.email || "",
    createdAt: serverTimestamp(),
  }));
}

export async function getHistoricoByDocumento(documentoId) {
  const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_historico")));
  const itens = snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(item => item.documentoId === documentoId)
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  return Promise.all(itens.map(async (item) => {
    if (item.userEmail || !item.userId) return item;
    try {
      const usuarioSnap = await getDoc(doc(db, "users", item.userId));
      const userEmail = usuarioSnap.exists() ? usuarioSnap.data()?.email || "" : "";
      return userEmail ? { ...item, userEmail } : item;
    } catch {
      return item;
    }
  }));
}
